import React, { useContext } from "react";
import AddIcon from "../../../shared/svg/AddIcon";
import { useNavigate } from "react-router-dom";
import {
    TitleWrapper,
    TitleText,
    StyledButton,
} from "../../../shared/styled/TitleBar";
import { AuthenticationContext } from "../../../provider/AuthenticationProvider";
import { ROLE } from "../../../data/enums";

const Title = () => {
    const navigate = useNavigate();
    const {
        user: { role },
    } = useContext(AuthenticationContext);
    const canCreate = role === ROLE.MANAGER;

    const onClickAddButton = () => {
        navigate("/extrafees/create");
    };

    return (
        <TitleWrapper>
            <TitleText>Danh sách chi phí</TitleText>
            {canCreate && (
                <StyledButton variant="contained" onClick={onClickAddButton}>
                    <AddIcon />
                    Tạo mới chi phí
                </StyledButton>
            )}
        </TitleWrapper>
    );
};

export default Title;
